<template>
  <DishScreen :slug="slug" />
</template>

<script setup lang="ts">
// Тонкая обёртка над экраном: маршрут Nuxt отдаёт slug, всё остальное — в ui/.
//
// Мидлвара живёт здесь: definePageMeta — макрос страницы, из ui/-компонента он
// не работает, а редирект на канонический адрес обязан случиться до рендера.
import { computed } from 'vue'
import DishScreen from './ui/DishScreen.vue'
import { useInstitutionStore } from '@entities/institution'
import { dishIdFromSlug, dishPath } from '@shared/lib'

/**
 * Ссылка с чужим названием в адресе (блюдо переименовали, ссылку скопировали
 * давно) или вовсе без него уезжает 301-м на канонический адрес: иначе одно
 * блюдо живёт в индексе под десятком адресов и делит между ними вес.
 *
 * Стор берём через $pinia явно — в мидлваре активного инстанса может не быть,
 * и данные прочитались бы из «чужого».
 */
definePageMeta({
  middleware(to) {
    const store = useInstitutionStore(useNuxtApp().$pinia as never)
    if (!store.institution) return

    const id = dishIdFromSlug(String(to.params.slug || ''))
    if (!id) return

    for (const category of store.products || []) {
      const item = ((category as any)?.products || []).find((entry: any) => Number(entry?.id) === id)
      if (!item) continue
      const canonical = dishPath(item)
      if (canonical && canonical !== to.path) {
        return navigateTo(canonical, { redirectCode: 301, replace: true })
      }
      return
    }
  },
})

const route = useRoute()
const slug = computed(() => String(route.params.slug || ''))
</script>
